module.exports = __webpack_public_path__ + "img/poster_txt_hs.363ee593.png";